export default {
    base : {
        login : "Login",
        pass : "Pass"
    }
}